import React from 'react';
import { warn } from '~/utils';
import Trigger from './dropdown-trigger';
import Menu from './dropdown-menu';
import Item from './dropdown-item';
import Popover from '../popover';
import { useControlledValue, useFunctionRef } from '~/hooks';
import { DropdownProvider } from './dropdown-context';
const DROPDOWN_NAME = 'vulcanui-dropdown';
function Dropdown(props) {
    const { children, closeOnSelect = true, defaultOpen = false, disabled, isDimissible = true, offset = 10, onClose, onOpen, onSelect: onSelectProp, onToggle, placement = 'bottom', portal = true, triggerType = 'click', isOpen: isOpenProp } = props;
    if (isDimissible && triggerType === 'hover')
        warn("isDimissable prop doesn't work with hover trigger type", 'Dropdown');
    const [isOpen, setIsOpen] = useControlledValue({ defaultProp: defaultOpen, prop: isOpenProp });
    const onSelect = useFunctionRef(onSelectProp);
    const selectHandler = React.useCallback((value) => {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(value);
        if (closeOnSelect)
            setIsOpen(false);
    }, [closeOnSelect, onSelect, setIsOpen]);
    const handleOpenChange = React.useCallback((nextOpen) => {
        if (nextOpen)
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        else
            onClose === null || onClose === void 0 ? void 0 : onClose();
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(nextOpen);
        setIsOpen(nextOpen);
    }, [onClose, onOpen, onToggle, setIsOpen]);
    return (React.createElement(DropdownProvider, { disabled: disabled, onSelect: selectHandler, portal: portal },
        React.createElement(Popover, { clickProps: { enabled: triggerType === 'click' }, dismissProps: { outsidePress: isDimissible }, hoverProps: { enabled: triggerType === 'hover', delay: 120 }, offset: offset, onOpenChange: handleOpenChange, open: isOpen && !disabled, placement: placement }, children)));
}
Dropdown.displayName = 'Dropdown';
Dropdown.toString = () => `.${DROPDOWN_NAME}`;
Dropdown.Trigger = Trigger;
Dropdown.Menu = Menu;
Dropdown.Item = Item;
export default Dropdown;
//# sourceMappingURL=dropdown.js.map